/*
 * Addisuna dataLayer events.
 *
 * Only the behaviour Shopify's own tracking cannot see. Standard ecommerce
 * events (view_item, add_to_cart, begin_checkout, purchase) already reach GA4
 * through the Google & YouTube channel's checkout pixel. Do NOT re-send those
 * here or GA4 will count every sale twice.
 *
 * Loaded only when a GTM container ID is set (see snippets/addisuna-gtm.liquid).
 * Everything is bound by delegation, so sections that are generated files
 * (the Origins Map) or injected late (Appstle's radios) need no edits.
 */
(function () {
  'use strict';

  function push(event, params) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: event }, params || {}));
  }

  document.addEventListener('click', function (e) {
    var target = e.target;
    if (!target || !target.closest) return;

    /* Origins Map: which coffee regions people actually open. Woliso is the
       mission marker, not a region, so it reports separately. */
    var marker = target.closest('[data-aom-region]');
    if (marker) {
      var region = marker.getAttribute('data-aom-region');
      if (region === 'woliso') {
        push('woliso_marker_open');
      } else {
        push('origins_region_open', { region: region });
      }
    }

    /* Review modal, opened from anywhere on the site. */
    /* `review_product`, not `product`: the page-load seed already put a product
       OBJECT on the dataLayer, and the dataLayer merges by key, so reusing
       `product` here would clobber it with a bare string. */
    var reviewTrigger = target.closest('[data-addisuna-review-open]');
    if (reviewTrigger) {
      push('review_modal_open', {
        review_product: reviewTrigger.getAttribute('data-addisuna-review-product') || 'unspecified'
      });
    }

    /* Donations leave the site for Zeffy, so GA4 never sees the outcome. The
       click is the only signal we get. */
    var link = target.closest('a[href]');
    if (link) {
      var host = '';
      try {
        host = new URL(link.href, window.location.href).hostname;
      } catch (err) {
        return;
      }
      if (host && host !== window.location.hostname) {
        push(host.indexOf('zeffy') !== -1 ? 'donate_click' : 'outbound_click', {
          destination: host,
          link_text: (link.textContent || '').trim().slice(0, 80)
        });
      }
    }
  });

  /* Subscribe and Save vs one-time. Appstle injects the radios asynchronously,
     so this listens on the document rather than binding to them directly. */
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || input.name !== 'selling_plan') return;

    var plan = input.value;
    push('purchase_option_selected', {
      purchase_option: plan ? 'subscription' : 'one_time',
      selling_plan_id: plan || null
    });
  });

  /* Review submissions post through the contact form, so catch the submit
     before the page navigates away. */
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || !form.closest || !form.closest('.arm-modal')) return;
      push('review_submitted');
    },
    true
  );
})();
